import React, { useState } from 'react'
import { Button, Card, Col, Collapse, Row, Typography } from 'antd'
import Testimonial1 from '../../../../images/register/testimonial-1.png'
import Testimonial2 from '../../../../images/register/testimonial-2.png'
import Testimonial3 from '../../../../images/register/testimonial-3.png'

const { Title, Paragraph } = Typography
const { Panel } = Collapse

import './index.less'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { useIntegrationContext } from '../../../../context/integration'

const ExpertRegisterPromo = () => {
	const [open, setOpen] = useState<boolean>(false)
	const { integration } = useIntegrationContext()

	if (integration.content?.register_expert) {
		return (
			<div
				className="register-promo register-expert-promo"
				dangerouslySetInnerHTML={{ __html: integration.content?.register_expert }}
			/>
		)
	}

	return (
		<div className="register-promo register-expert-promo">
			<Title level={2}>You’re invited to Join Us as an Expert, Coach or Mentor</Title>
			<Paragraph>
				Get more visibility, get PAID, give back and attract new customers all while helping professionals and business
				owners thrive!
			</Paragraph>
			<Button className="mobile toggle-btn" shape="round" type="default" onClick={() => setOpen(!open)}>
				{open ? 'Less' : 'More'} Info
			</Button>
			<div className={`toggle-content ${open ? 'opened' : ''}`}>
				<Title level={3} style={{ marginBottom: 20, marginTop: 30 }}>
					Why Join?
				</Title>
				<div className="mobile">
					<Collapse
						expandIconPosition="right"
						ghost
						expandIcon={({ isActive }) =>
							isActive ? (
								<MinusOutlined style={{ fontSize: 15, color: '#FFFFFF' }} />
							) : (
								<PlusOutlined style={{ fontSize: 15, color: '#0067A8' }} />
							)
						}
					>
						<Panel header={<strong>No more “brain picking”</strong>} key="1">
							<Paragraph>
								Turn those free consultations, or coffee chats into a way to help others in business around the world
								AND make some money (or donate your portion to our foundation)!
							</Paragraph>
						</Panel>
						<Panel header={<strong>Increased Visibility</strong>} key="2">
							<Paragraph>
								You will gain visibility through our our social networks and our email list of 150,000 +. We have
								national partnerships with large business and career focused corporations and you will be invited to
								submit content and do webinars to spotlight you and your business.
							</Paragraph>
						</Panel>
						<Panel header={<strong>Attracting New Clients or Talent</strong>} key="3">
							<Paragraph>
								getWise members may end up as a client or a new hire once they become familiar with you and your
								organization. As long as you focus on answering their questions, you are allowed promote your own
								business as well! (We actually encourage it!)
							</Paragraph>
						</Panel>
						<Panel header={<strong>Grant Opportunities</strong>} key="4">
							<Paragraph>
								We set aside a portion of profits yearly to provide grants to those underrepresented in business. The
								more calls we do, the more impact we have and the more money we can give! Experts are also eligible to
								apply for grants!
							</Paragraph>
						</Panel>
					</Collapse>
				</div>
				<div className="desktop">
					<Paragraph>
						<strong>No more “brain picking”</strong> - Turn those free consultations, or coffee chats into a way to help
						others in business around the world AND make some money (or donate your portion to our foundation)!
					</Paragraph>
					<Paragraph>
						<strong>Increased Visibility</strong> - You will gain visibility through our our social networks and our
						email list of 150,000 +. We have national partnerships with large business and career focused corporations
						and you will be invited to submit content and do webinars to spotlight you and your business.
					</Paragraph>
					<Paragraph>
						<strong>Attracting New Clients or Talent</strong> - getWise members may end up as a client or a new hire
						once they become familiar with you and your organization. As long as you focus on answering their questions,
						you are allowed promote your own business as well! (We actually encourage it!)
					</Paragraph>
					<Paragraph>
						<strong>Grant Opportunities</strong> - We set aside a portion of profits yearly to provide grants to those
						underrepresented in business. The more calls we do, the more impact we have and the more money we can give!
						Experts are also eligible to apply for grants!
					</Paragraph>
				</div>
				<Title level={3} style={{ marginTop: 30 }}>
					Want to know more?
				</Title>
				<Paragraph>
					Jump to our{' '}
					<a href="https://getwiseconnect.com/faqs">
						<strong>FAQ!</strong>
					</a>
				</Paragraph>
				<div className="testimonials-container">
					<div className="testimonials-wrapper">
						<Title level={3} style={{ marginBottom: 40 }}>
							Dont just take our word for it
						</Title>
						<Row gutter={[30, 30]}>
							<Col lg={8} xs={24} md={12}>
								<Card bordered={false} className="testimonial">
									<div className="testimonial-img">
										<img src={Testimonial1} alt="Lou Bortone" />
									</div>
									<strong className="testimonial-name">Lou Bortone</strong>
									<span className="testimonial-position">Video Marketing Consultant</span>
									<Paragraph>
										{`
										It's really an honor to be part of the amazing getWise community - especially as one of the few men
										and allies! As an expert on the platform, I've had the opportunity to work with dozens of inspiring
										business owners. As a result, my own visibility and profile have grown exponentially. I'm forever
										grateful to Kathryn and the community at getWise for the opportunity.
									`}
									</Paragraph>
								</Card>
							</Col>
							<Col lg={8} xs={24} md={12}>
								<Card bordered={false} className="testimonial">
									<div className="testimonial-img">
										<img src={Testimonial2} alt="Precious Williams" />
									</div>
									<strong className="testimonial-name">Precious Williams</strong>
									<span className="testimonial-position">Founder, Perfect Pitches by Precious</span>
									<Paragraph>
										{`
										In being a getWise expert, I have been blessed to have clients who one 1st place in their pitch
										competitions and bought additional training and coaching programs.  In addition, I have been a
										featured speaker for Dell and other opportunities for me, as a woman and black woman to shine.
									`}
									</Paragraph>
								</Card>
							</Col>
							<Col lg={8} xs={24} md={12}>
								<Card bordered={false} className="testimonial">
									<div className="testimonial-img">
										<img src={Testimonial3} alt="Ilhiana Rojas Saldana" />
									</div>
									<strong className="testimonial-name">Ilhiana Rojas Saldana</strong>
									<span className="testimonial-position">Founder, BeLIVE Coaching and Consulting</span>
									<Paragraph>
										I am so grateful to work as a getWise expert and consultant. getWise has gone above and beyond to
										provide the resources, knowledge, network and support needed for business owners to thrive. My
										business has grown to have global recognition as a result of getWise and I’m proud to be a part of
										this company.
									</Paragraph>
								</Card>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ExpertRegisterPromo
